import React from 'react';
import './default_menu_layout.scss';
import DefaultHeader from './default_header';

function DefaultMenuLayout(props) {
  return (
    <div className="default-menu-layout">

      <DefaultHeader
        className="default-menu-layout__header"
        showBackButton={props.showBackButton}
        history={props.history}
        onBackClick={props.onBackClick ? () => props.onBackClick() : null}
        token={props.token}
        target_service={props.target_service}
        bluetoothDevices={props.bluetoothDevices}
        showOperationalTasksLink={props.showOperationalTasksLink}
        system_name={props.system_name}
        system_logo_url={props.system_logo_url}
        system_primary_color={props.system_primary_color}
        system_primary_contrast_color={props.system_primary_contrast_color}
        system_secondary_color={props.system_secondary_color}
        system_secondary_contrast_color={props.system_secondary_contrast_color}
      />

      <main className="default-menu-layout__main">

        {props.children}

      </main>

    </div>
  );
}

export default DefaultMenuLayout;
